import {
  styled,
  Button,
  Box,
  TextField,
  useTheme,
  colors,
} from '@mui/material';
import { COLORS } from '../../../utils/colors';
import { useMemo } from 'react';

export const useInspectorStyles = () => {
  const theme = useTheme();

  return useMemo(
    () => ({
      header: {
        bgcolor: COLORS.WHITE,
        boxShadow: '0 .125rem .5rem 0 rgba(0, 0, 0, 0.1)',
        height: '3.125rem',
        display: 'flex',
        alignItems: 'center',
        px: '1.25rem',
        position: 'relative',
        zIndex: 1400,
        justifyContent: 'space-between',
      },
      viewTitle: {
        borderTop: '1px solid #ebebeb',
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'flex-end',
        borderBottom: `1px solid ${theme.palette.divider}`,
        fontWeight: 500,
        pb: '.1125rem',
        background: '#fff',
        marginTop: '-1px',
      },
      transcriptsPanel: {
        paddingTop: '2rem !important',
        background: '#fff',
        overflowY: 'scroll',
        height: `calc(100% - 5.5rem)`,
        width: '100%',
        padding: '1rem',
      },
      imageWrap: {
        cursor: 'pointer',
        width: '6rem',
        display: 'inline-block',
        marginRight: '3rem',
      },
      savedScreenshot: {
        display: 'block',
        transition: '0.5s ease',
        borderRadius: '.625rem',
        objectFit: 'cover',
        marginBottom: '.75rem',
        width: '100%',
        height: '100%',
      },
      participant: {
        display: 'flex',
        alignItems: 'center',
        ml: '1rem',
      },
      stats: {
        color: '#888',
      },
      title: {
        marginLeft: '.75rem',
        fontWeight: '600',
        fontSize: '1.25rem',
      },
      circle: {
        bgcolor: '#5bd447',
        height: '.375rem',
        width: '.375rem',
        borderRadius: '.1875rem',
      },
      online: {
        color: '#5bd447',
        marginLeft: '.5rem',
        fontSize: '.875rem',
      },
      endCall: {
        fontWeight: '500',
        textAlign: 'center',
        mt: '1.25rem',
        color: '#fff',
        textDecoration: 'underline',
        cursor: 'pointer',
      },
      consentModal: {
        fontWeight: '500',
        textAlign: 'center',
        mt: '1.25rem',
        color: '#000',
        textDecoration: 'underline',
        cursor: 'pointer',
      },
      modalSub: {
        fontWeight: '400',
        textAlign: 'center',
        color: '#fff',
      },
      room: {
        height: '100%',
        width: '100%',
      },
      view: {
        display: 'flex',
        width: '100%',
        height: '100%',
        position: 'relative',
        overflow: 'hidden',
      },
      sidebar: {
        background: '#222222',
        height: '100%',
        width: '4.5rem',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        borderRight: `0.5px solid ${COLORS.MEDIUM_GRAY}`,
        position: 'relative',
        zIndex: 1,
        paddingTop: '1rem',
      },
      sidebarHangUp: {
        height: '2.5rem',
        width: '2.5rem',
        borderRadius: '1.25rem',
        bgcolor: COLORS.PRIMARY,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        mt: 'auto',
        mb: '15rem',
      },
      flipCamera: {
        fontSize: '.8125rem',
        fontWeight: '500',
      },
      sidebarLeftButton: {
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        my: '.25rem',
        width: '2rem',
        height: '2rem',
        padding: '2rem',
        borderRadius: '5rem',
      },
      sidebarRightButton: {
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        my: '.75rem',
        width: '2rem',
        height: '2rem',
        padding: '1.5rem',
        borderRadius: '5rem',
        border: `1px solid ${COLORS.MEDIUM_GRAY}`,
      },
      leftSidebarButton: {
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        py: '.4025rem',
        width: '100%',
      },
      sidbarIcon: {
        color: 'inherit',
        paddingBottom: '0.1rem',
      },
      sidebarButtonLabel: {
        userSelect: 'none',
        fontSize: '.625rem',
        padding: '0 .5rem',
        textAlign: 'center',
        whiteSpace: 'nowrap',
      },
      sidebarConsent: {
        bgcolor: 'white',
        p: '.75rem',
        position: 'absolute',
        width: '12.5rem',
        borderRadius: '.625rem',
        left: '4.75rem',
        top: '9.5rem',
        zIndex: 200,
      },
      captureButton: {
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        py: '.5625rem',

        background:
          'radial-gradient(circle, #222222 58%, rgb(220 220 220) 100%)',
        borderRadius: '50%',
        width: '5.5rem',
        height: '5.5rem',
        transform: 'translateX(.5rem)',
        margin: '1rem 0',
        marginLeft: '-17px',
      },
      canvasTools: {
        background: COLORS.WHITE,
        height: '100%',
        width: '5.025rem',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        borderLeft: `0.5px solid ${COLORS.LIGHT_GRAY}`,
        borderRight: `0.5px solid ${COLORS.LIGHT_GRAY}`,
        position: 'relative',
        zIndex: 1,
      },
      canvasIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        py: '.4425rem',
        width: '100%',
      },
      localPreview: {
        bgcolor: COLORS.DARK_GREY,
        borderRadius: '.75rem',
        width: '10.9375rem',
        height: '12.5rem',
        position: 'absolute',
        bottom: '.75rem',
        left: '.75rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid white',
        zIndex: 10,
      },
      localVideoTrack: {
        width: '100%',
        height: '100%',
        transition: 'opacity 0.2s ease-in-out',
        borderRadius: '1.1rem',
      },
      localVideoTrackIconsWrapper: {
        position: 'absolute',
        width: '100%',
        bottom: 0,
        height: '2.5rem',
        display: 'flex',
        alignItems: 'center',
      },
      localVideoTrackIcon: {
        zIndex: 11,
        mx: '.375rem',
        bgcolor: 'white',
        borderRadius: '1.25rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: `1px solid ${COLORS.LIGHT_GRAY}`,
      },
      localSettingsIcon: {
        marginLeft: 'auto',
      },
      pointer: {
        width: '2rem',
        height: '2rem',
        color: '#ff0',
      },
      videoTrack: {
        height: '100%',
        width: '100%',
        objectFit: 'cover',
        borderRadius: '.625rem',
        position: 'absolute',
        top: 0,
        left: 0,
        transition: 'all .2s',
      },
      videoContainer: {
        cursor: 'none',
        height: '100%',
        width: '100%',
        overflow: 'hidden',
        alignItems: 'center',
        justifyContent: 'center',
      },
      remoteVideoTrackWrapper: {
        height: '100%',
        width: '100%',
        overflow: 'clip',
      },
      vhcInfo: {
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: COLORS.LIGHT_GRAY,
        paddingTop: '0.7rem',
        paddingRight: 0,
        position: 'relative',
        borderLeft: `1px solid ${COLORS.MEDIUM_GRAY}`,
      },
      startButtons: {
        flexDirection: 'column',
        alignItems: 'center',
      },
      sendSessionLink: {
        fontSize: '.8125rem',
        padding: '.375rem .75rem',
        minWidth: '12rem',
        textTransform: 'none',
      },
      moreButton: {
        fontSize: '1rem',
        fontWeight: '400',
        padding: '.3125rem .75rem',
        minWidth: '12rem',
        textTransform: 'none !important',
        background: '#fff !important',
        color: '#FF6E00',
      },
      callMobile: {
        marginTop: '2rem',
        fontSize: '.8125rem',
        padding: '.3125rem .75rem',
        minWidth: '10rem',
        borderRadius: '1rem',
        border: '1px solid #ff6e00',
      },
      moreOptions: {
        fontSize: '.8125rem',
        padding: '.3125rem .75rem',
        minWidth: '12rem',
        mt: '2rem',
        textTransform: 'none',
        '&:hover': {
          color: '#ccc',
          transform: 'scale(1.05)',
          transition: 'all 0.2s ease-in-out',
          background: 'transparent',
        },
      },
      remotePanel: {
        borderRadius: '0 .6875rem 0 0',
        width: '100%',
        display: 'flex',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
      },
      canvasArea: {
        backgroundColor: 'transparent',
        width: '100%',
        height: '100%',
      },
      canvasProgress: {
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
      },
      editorCanvasWrapper: {
        overflow: 'hidden',
        position: 'relative',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      screenshot: {
        position: 'absolute',
        margin: 'auto',
        zIndex: 0,
      },
      canvasShapes: {
        bgcolor: COLORS.WHITE,
        position: 'absolute',
        top: 'calc(10.5rem + 2px)',
        left: 'calc(5rem + 2px)',
        zIndex: 10,
      },
      canvasPen: {
        bgcolor: COLORS.WHITE,
        position: 'absolute',
        top: 'calc(15.5rem + 2px)',
        left: 'calc(5rem + 2px)',
        padding: '1rem',
        height: '4rem',
        width: '10rem',
        textAlign: 'center',
        zIndex: 10,
      },
      canvaslayers: {
        bgcolor: COLORS.WHITE,
        position: 'absolute',
        top: 'calc(25.5rem + 2px)',
        left: 'calc(5rem + 2px)',
        width: '10rem',
        textAlign: 'center',
        zIndex: 1,
      },
      strokesLayer: {
        display: 'flex',
        width: '100%',
        padding: '.5rem',
        cursor: 'pointer',
      },
      exitButton: {
        textTransform: 'none',
        width: '6.2rem',
        padding: '0.2rem',
      },
      rescheduleSession: {
        color: 'inherit',
        fontWeight: 500,
        fontSize: '.8125rem',
        marginRight: '3rem',
        cursor: 'pointer',
      },
      closeWaitingModal: {
        position: 'absolute',
        top: '.1875rem',
        right: '.1875rem',
        color: '#fff',
      },
      closeConsentModal: {
        position: 'absolute',
        top: '.1875rem',
        right: '.1875rem',
        color: '#000',
      },
      unreadMessageIndicator: {
        height: '.75rem',
        width: '.75rem',
        borderRadius: '.375rem',
        bgcolor: COLORS.PRIMARY,
        position: 'absolute',
        top: '.3125rem',
        right: '.4375rem',
      },
      roomPanel: {
        position: 'relative',
        display: 'flex',
      },
      viewsPanel: {
        flex: 1,
        marginLeft: '-1rem',
      },
      // copilotPanel: {
      //   overflowY: 'scroll',
      //   marginTop: 0,
      //   height: '100%'
      // },
      modalBox: {
        p: '1rem',
        pb: '0',
        backgroundColor: 'white',
        borderRadius: '.5rem',
        boxShadow: '0 .25rem .5rem rgba(0, 0, 0, 0.1)',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      },
      alternativeNumberBox: {
        display: 'flex',
        alignItems: 'center',
        mt: '1.875rem',
        mb: '1.875rem',
      },
      alternativeNumberInput: {
        minWidth: '30rem',
        '& .MuiInputBase-input': {
          padding: '.75rem',
        },
        '& .MuiInputLabel-root': {
          transform: 'translate(14px, 12px) scale(1)',
        },
        '& .MuiInputLabel-shrink': {
          transform: 'translate(14px, -6px) scale(0.75)',
        },
      },
      alternativeNumberButtons: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mt: '1.875rem',
        mb: '.5rem',
      },
      imageDimensions: {
        position: 'absolute',
        bottom: 8,
        right: 8,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        color: '#fff',
        padding: '4px 8px',
        borderRadius: '4px',
        fontSize: '12px',
        fontFamily: 'monospace',
        zIndex: 1,
      },
      mediaCheckModal: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 'min(50vw, 55rem)',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        maxHeight: '80vh',
        overflowY: 'auto',
      },
      name: {
        color: 'white',
        position: 'absolute',
        fontSize: '.75rem',
        top: '.25rem',
        left: '.25rem',
        width: '100%',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        paddingRight: '1rem',
      },
      trayStyle: {
        position: 'absolute',
        left: '100%',
        top: 0,
        backgroundColor: 'rgba(0,0,0,0.8)',
        borderRadius: '4px',
        ml: '0.125rem',
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        p: 1,
      },
    }),
    [theme],
  );
};

export const StyledHeaderButton = styled(Button)({
  bgcolor: COLORS.WHITE,
  borderRadius: '1.75rem',
  padding: '.3125rem 1.75rem',
  color: COLORS.PRIMARY,
  transition: 'all 0.2s',
  '&:hover': {
    bgcolor: COLORS.WHITE,
    transform: 'scale(1.01)',
  },
});

export const StyledTabs = styled(Box)({
  '& .MuiTabs-indicator': {
    bgcolor: COLORS.PRIMARY,
  },
  '& .MuiTab-root.Mui-selected': {
    color: COLORS.PRIMARY,
  },
});

export const StyledTextarea = styled(TextField)({
  '& .MuiOutlinedInput-root, ': {
    borderRadius: '.625rem',
    height: '100%',
    bgcolor: 'white',
    marginRight: '.5rem',
    width: '100%',
  },
  '& .MuiOutlinedInput-input': {
    height: '100% !important',
  },
});

export const useReportStyles = () => {
  return {
    allScreenshotsIcon: {
      background: '#fff',
      ':hover': {
        background: '#fff',
      },
    },
  };
};

export const StyledImageOverlay = styled(Box)({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '8.75rem',
  height: '8.75rem',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  color: 'white',
  background: 'rgba(26, 38, 96, 0.4)',
  opacity: 0,
  transition: 'opacity 0.3s ease',
  borderRadius: '.625rem',
  cursor: 'pointer',
  ':hover': {
    opacity: 1,
  },
});

export const Sentence = styled(Box)({
  color: COLORS.PRIMARY,
  display: 'inline',
  transition: 'all 0.2s',
  '&:hover': {
    bgcolor: COLORS.WHITE,
    transform: 'scale(1.01)',
  },
});
